// @flow
import * as React from 'react';
import {
  ButtonBase, Divider, IconButton, Popover, PopoverProps,
  Stack,
  Typography
} from '@mui/material';
import { useState } from 'react';
import { X } from '@phosphor-icons/react';
import { ProviderAddressOutput, ProviderOutput } from '@coverright/data-access/types/medicare';

type Props = {
  doctor: ProviderOutput,
  onEditClick: () => void,
  onDeleteClick: () => void,
};
export const DoctorItem = ({doctor, onEditClick, onDeleteClick}: Props) => {
  const [disableRipple, setDisableRipple] = useState(false)
  const [anchorEl, setAnchorEl] = React.useState(null);

  return (
    <ButtonBase component={Stack} gap={1}
                disableRipple={disableRipple}
                onClick={onEditClick}
                sx={{p: '12px 16px', width: 1, flexDirection: 'row', justifyContent: 'space-between', '&:hover': {bgcolor: 'secondary.50'}}}>
      <Stack flex={1}>
        <Typography variant={'body2'} fontWeight={500}>{doctor.name}</Typography>
        <Typography variant={'caption'} color={'text.secondary'}>
          {doctor.addresses[0]?.specialty} | PCP: {doctor.pcpDetails ? doctor.pcpDetails[0]?.pcpId : '-'}
        </Typography>
      </Stack>

      <Stack gap={.5} direction={'row'}>
        <Stack>
          <Typography variant={'caption'} color={'text.secondary'} align={'right'}>
            {doctor.addresses[0]?.addressLine1}
          </Typography>
          <Typography variant={'caption'} color={'text.secondary'} align={'right'}>
            {doctor.addresses[0]?.addressLine2}
          </Typography>
        </Stack>
        {doctor.addresses.length > 1 && <>
          <Typography alignSelf={'flex-start'}
                      onMouseEnter={(event: any) => {
                        setAnchorEl(event.currentTarget);
                      }}
                      onMouseLeave={() => {
                        setAnchorEl(null);
                      }}
                      variant={'caption'}
                      color={'text.secondary'} align={'right'}>
            <b>+{doctor.addresses.length - 1}</b>
          </Typography>
          <Addresses addresses={doctor.addresses.slice(1)} anchorEl={anchorEl} open={Boolean(anchorEl)} />
        </>}
      </Stack>

      <IconButton size={'small'} onClick={r => {
        r.stopPropagation();
        onDeleteClick()
      }}
                  onMouseEnter={() => setDisableRipple(true)}
                  onMouseLeave={() => setDisableRipple(false)}>
        <X size={16} color={'#DE3124'} />
      </IconButton>
    </ButtonBase>
  );
};

const Addresses = ({addresses, ...rest}: PopoverProps & {addresses: ProviderAddressOutput[]}) => (
  <Popover
    sx={{pointerEvents: 'none'}}
    slotProps={{
      paper: {
        sx: {px: 2, py: 1}
      }
    }}
    disableRestoreFocus
    hideBackdrop
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}
    {...rest}
  >
    {addresses.map((a, i, array) => <div key={i}>
      <AddressBlock address={a} />
    {i < array.length - 1 && <Divider/>}
  </div>)}
  </Popover>
)

const AddressBlock = ({address}: {address: ProviderAddressOutput}) => (
  <div>
    <Typography variant={'body2'}>{address?.addressLine1}</Typography>
    <Typography variant={'body2'}>{address?.addressLine2}</Typography>
  </div>
)
